import React from "react";
import Summary from "../../../../components/cases/assets/balanceOfAssets/shareholdings/Summary";

const ShareHoldings = ({ next, back, tabText }) => {
  return (
    <>
      <Summary next={next} back={back} />
      {/* <SuggestionBox
        mainText={tabText}
        tabName="Shareholdings"
        setVisited={visited}
      /> */}
    </>
  );
};

export default ShareHoldings;
